export default class Settings {
}

Settings.tags = 'tags';




// WEBPACK FOOTER //
// ./src/Settings.js